const REDACTED_VALUE = '[REDACTED]';
const CIRCULAR_VALUE = '[Circular]';
const SENSITIVE_KEYS = new Set([
    'accesstoken',
    'anydeskpassword',
    'authorization',
    'cookie',
    'jwt',
    'password',
    'privatekey',
    'refreshtoken',
    'secret',
    'setcookie',
    'token',
]);
const normalizeKey = (key) => key.replace(/[^a-z0-9]/gi, '').toLowerCase();
const isSensitiveKey = (key) => {
    const normalizedKey = normalizeKey(key);
    return SENSITIVE_KEYS.has(normalizedKey);
};
const looksLikeJson = (value) => {
    const trimmedValue = value.trim();
    return (trimmedValue.startsWith('{') && trimmedValue.endsWith('}')) || (trimmedValue.startsWith('[') && trimmedValue.endsWith(']'));
};
const sanitizeValue = (value, seen) => {
    if (value === null || value === undefined) {
        return value;
    }
    if (typeof value === 'string') {
        if (!looksLikeJson(value)) {
            return value;
        }
        try {
            const parsedValue = JSON.parse(value);
            return JSON.stringify(sanitizeValue(parsedValue, seen));
        }
        catch {
            return value;
        }
    }
    if (typeof value !== 'object') {
        return value;
    }
    if (value instanceof Date) {
        return value;
    }
    if (value instanceof Error) {
        if (seen.has(value)) {
            return CIRCULAR_VALUE;
        }
        seen.add(value);
        const sanitizedError = {
            name: value.name,
            message: value.message,
        };
        if (value.stack) {
            sanitizedError.stack = value.stack;
        }
        for (const [key, nestedValue] of Object.entries(value)) {
            sanitizedError[key] = isSensitiveKey(key) ? REDACTED_VALUE : sanitizeValue(nestedValue, seen);
        }
        seen.delete(value);
        return sanitizedError;
    }
    if (Array.isArray(value)) {
        return value.map(item => sanitizeValue(item, seen));
    }
    if (seen.has(value)) {
        return CIRCULAR_VALUE;
    }
    seen.add(value);
    const sanitizedObject = {};
    for (const [key, nestedValue] of Object.entries(value)) {
        sanitizedObject[key] = isSensitiveKey(key) ? REDACTED_VALUE : sanitizeValue(nestedValue, seen);
    }
    seen.delete(value);
    return sanitizedObject;
};
export const sanitizeForLogging = (value) => sanitizeValue(value, new WeakSet());
//# sourceMappingURL=LogSanitizer.js.map